module.exports = __webpack_public_path__ + "media/images/retail-f1f65f12dd272c05fae588af9d66dc3f.svg";